import React, { SyntheticEvent } from 'react';

import { PaginationView } from './Pagination.view';

export interface PaginationProps {
  selected?: number;
  selectedValue?: number;
  from: number;
  to: number;
  onChange: (selectedPage: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  selected,
  selectedValue,
  from,
  to,
  onChange,
}: PaginationProps) => {
  const generatePages = (startIndex = 1, endIndex = 0) => {
    return Array.from(
      { length: Math.max(1, 1 + endIndex - startIndex) },
      (_v, index) => index + startIndex
    );
  };

  const pages = generatePages(from, to);

  const handleChangePage = (_event: SyntheticEvent, value: number) => {
    onChange(value);
  };

  const selectedIndex = selected || pages.indexOf(selectedValue);

  return (
    <PaginationView
      pages={pages}
      selectedIndex={selectedIndex >= 0 ? selectedIndex : null}
      onChange={handleChangePage}
    />
  );
};
